import React, { useContext } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import tfbank21_logo_white from 'img/tf-logos/tfbank21-logo-white.svg'

import SspContext from 'selfServicePortal/contexts/SspContext'

import { ICountryValues } from 'shared/constants/countryValueTypes'

import './Footer.scss'

const Footer = () => {
	const { t } = useTranslation()
	const { staticCountryValues, productType } = useContext(SspContext)

	interface IFooterProps {
		val: ICountryValues
	}

	const FooterNorway = ({ val }: IFooterProps) => {
		return (
			<div className="footer-content-row">
				<div className="footer-contact-information">
					<img
						src={tfbank21_logo_white}
						alt="tf-logo"
						className="logo-footer"
					/>
					<div>
						<div>
							{Object.entries(val.address).map(([key, value]) => {
								return (
									<div key={'address-item-' + key}>
										{value}
									</div>
								)
							})}
						</div>
						{val.productSpecific.map((value, key) => {
							if (value.productType === productType) {
								return (
									<div key={'footer-contact-item-' + key}>
										<div>
											{value.contactInformation.email}
										</div>
										<div>
											{
												value.contactInformation
													.phoneNumber
											}
										</div>
									</div>
								)
							} else return null
						})}
					</div>
				</div>
			</div>
		)
	}

	const FooterGermanyAustria = ({ val }: IFooterProps) => {
		return (
			<div className="footer-content-row">
				<div className="footer-contact-information">
					<img
						src={tfbank21_logo_white}
						alt="tf-logo"
						className="logo-footer"
					/>
					<div>
						{Object.entries(val.address).map(([key, value]) => {
							return <div key={key}>{value}</div>
						})}
					</div>
				</div>
				<div className="footer-links">
					{Object.entries(val.links).map(([key, value]) => {
						return (
							<div
								key={'footer-link-' + key}
								className={'footer-link-item'}>
								<div>
									<a
										href={value.link}
										target="_blank"
										rel="noopener noreferrer">
										{t(value.title)}
									</a>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		)
	}

	return (
		<div className="footer">
			<Container>
				{staticCountryValues === undefined ? null : (
					<>
						{staticCountryValues.country === 'no' ? (
							<FooterNorway val={staticCountryValues} />
						) : (
							<FooterGermanyAustria val={staticCountryValues} />
						)}
					</>
				)}
				<div className="border-footer">
					<div className="footer-copy-right">
						{`© ${new Date().getFullYear()} ${
							staticCountryValues === undefined
								? 'TF Bank AB'
								: staticCountryValues?.copyRight
						}`}
					</div>
				</div>
			</Container>
		</div>
	)
}
export default Footer
